/* ABC: смена размера и цвета прямо в корзине (мини-корзина и /cart).
   Нажатие на «SIZE: S» — окно со списком размеров; на «COLOR: ASH» — окно
   со списком цветов (текстом, без картинок). Выбор = строка убирается и
   добавляется нужный вариант с тем же количеством, корзина перерисовывается.
   Если в новом цвете нет того же размера — сразу предлагаем выбрать размер.
   Данные товара — /products/<handle>?view=abcjson (templates/product.abcjson.liquid). */
import { CartLinesUpdateEvent } from '@shopify/events';

const cache = {};
function load(handle) {
  if (!cache[handle]) {
    cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=abcjson')
      .then((r) => (r.ok ? r.text() : null))
      .then((t) => { try { return t ? JSON.parse(t) : null; } catch (e) { return null; } })
      .catch(() => null);
  }
  return cache[handle];
}

function sectionIds() {
  return Array.from(document.querySelectorAll('cart-items-component')).map((el) => el.dataset.sectionId).filter(Boolean);
}

function rowInfo(row) {
  const key = row.dataset.key || '';
  const link = row.querySelector('a[href*="/products/"]');
  const handle = link ? (new URL(link.href, location.origin).pathname.match(/\/products\/([^/?#]+)/) || [])[1] : '';
  const input = row.querySelector('.cart-items__quantity input');
  return { key, variantId: Number(key.split(':')[0]), handle, inDrawer: !!row.closest('#cart-drawer'), qty: Math.max(1, parseInt(input && input.value, 10) || 1) };
}

async function swap(info, newVariantId) {
  if (newVariantId === info.variantId) return;
  const deferred = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(new CartLinesUpdateEvent({
    action: 'update', context: 'cart',
    lines: [{ merchandiseId: String(newVariantId), quantity: info.qty }],
    promise: deferred.promise,
  }));
  try {
    /* ОДИН запрос вместо трёх: старую строку в 0, новый вариант — нужное
       количество (если он уже лежит в корзине — прибавляем к тому, что есть),
       и сразу HTML корзины для перерисовки */
    let existing = 0;
    document.querySelectorAll('cart-items-component .cart-items__table-row[data-key]').forEach((r) => {
      if (r.closest('#cart-drawer') && !info.inDrawer) return;
      if (!r.closest('#cart-drawer') && info.inDrawer) return;
      if (Number((r.dataset.key || '').split(':')[0]) === newVariantId) {
        const q = r.querySelector('.cart-items__quantity input');
        existing += parseInt(q && q.value, 10) || 0;
      }
    });
    const updates = {};
    updates[info.key] = 0;
    updates[newVariantId] = existing + info.qty;
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, sections: sectionIds().join(','), sections_url: location.pathname }),
    });
    const cart = await res.json();
    if (!res.ok || !cart.sections) throw new Error('update');
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { sections: cart.sections, items: cart.items, itemCount: cart.item_count, source: 'abc-cart-edit', didError: false },
    });
  } catch (e) {
    deferred.reject(e);
  }
}

function optionButton(text, { current = false, sold = false, note = '' } = {}) {
  const b = document.createElement('button');
  b.type = 'button';
  b.className = 'abc-sheet__opt' + (sold ? ' is-sold' : '') + (current ? ' is-current' : '');
  b.innerHTML = '<span></span>' + (note ? '<small></small>' : '');
  b.firstChild.textContent = text;
  if (note) b.lastChild.textContent = note;
  return b;
}

function sizeSheet(product, info, currentVariantId) {
  const box = document.createElement('div');
  (product.variants || []).forEach((v) => {
    const b = optionButton(v.title, { current: v.id === currentVariantId, sold: !v.available, note: v.available ? '' : 'Notify me' });
    b.addEventListener('click', async () => {
      if (!v.available) {
        window.abcSheet.open({ title: 'Notify me', body: window.abcSheet.notifyForm({ title: product.title, handle: product.handle }, v.title), anchor: info.inDrawer ? '#cart-drawer dialog[open]' : null });
        return;
      }
      /* окно закрываем сразу — корзина перерисуется, как только ответит сервер */
      window.abcSheet.close(() => swap(info, v.id));
    });
    box.appendChild(b);
  });
  window.abcSheet.open({ title: 'Select a size', body: box, anchor: info.inDrawer ? '#cart-drawer dialog[open]' : null });
}

function colorSheet(product, info) {
  const box = document.createElement('div');
  const currentSize = ((product.variants || []).find((v) => v.id === info.variantId) || {}).title;
  (product.siblings || []).forEach((s) => {
    const b = optionButton(s.colorway, { current: s.handle === product.handle, sold: !s.available, note: s.available ? '' : 'Sold out' });
    b.addEventListener('click', async () => {
      if (s.handle === product.handle) { window.abcSheet.close(); return; }
      if (!s.available) return;
      box.querySelectorAll('button').forEach((x) => (x.disabled = true));
      const next = await load(s.handle);
      if (!next) { window.abcSheet.close(); return; }
      const same = (next.variants || []).find((v) => v.title === currentSize && v.available);
      if (same) { window.abcSheet.close(() => swap(info, same.id)); }
      else sizeSheet(next, info, null);   /* того же размера нет — выбрать другой */
    });
    box.appendChild(b);
  });
  window.abcSheet.open({ title: 'Select a color', body: box, anchor: info.inDrawer ? '#cart-drawer dialog[open]' : null });
}

/* данные товара начинаем грузить уже при касании — окно откроется быстрее */
document.addEventListener('pointerdown', (e) => {
  const el = e.target.closest && e.target.closest('.cart-items__table-row .cart-items__variants dd, .cart-items__table-row .abc-cart-color');
  if (!el) return;
  const info = rowInfo(el.closest('.cart-items__table-row'));
  if (info.handle) load(info.handle);
}, true);

document.addEventListener('click', async (e) => {
  let sizeEl = e.target.closest && e.target.closest('.cart-items__table-row .cart-items__variants-wrapper dl > div, .cart-items__table-row .cart-items__variants-wrapper dd, .cart-items__table-row .cart-items__variants-wrapper dt');
  /* ABC 02.10: сумма GIFT CARD и строки получателя (Recipient…) — не размер, окно не открываем */
  if (sizeEl && sizeEl.closest('.abc-cart-gc, .cart-items__properties')) sizeEl = null;
  const colorEl = e.target.closest && e.target.closest('.cart-items__table-row .abc-cart-color');
  if (!sizeEl && !colorEl) return;
  if (!window.abcSheet) return;
  e.preventDefault();
  e.stopPropagation();
  const row = (sizeEl || colorEl).closest('.cart-items__table-row');
  const info = rowInfo(row);
  if (!info.handle || !info.variantId) return;
  const product = await load(info.handle);
  if (!product) return;
  if (colorEl) {
    if ((product.siblings || []).length > 1) colorSheet(product, info);
  } else if ((product.variants || []).length > 1) {
    sizeSheet(product, info, info.variantId);
  }
}, true);
